var map = {
	"./icon-ellipsis.svg": 109,
	"./icon-exercise.svg": 71,
	"./icon-play.svg": 371,
	"./icon-self-care.svg": 415,
	"./icon-social.svg": 128,
	"./icon-study.svg": 437,
	"./icon-work.svg": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;